export default function gtmPush(event) {
    if (process.env.NODE_ENV === "development") {
        console.log(event);
    }
    if (!window.dataLayer) return;
    window.dataLayer.push(event);
}
